// Msal imports
import { MsalAuthenticationTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../../authConfig";


// Sample app imports
import { Loading } from "../../components/Loading";
import { ErrorComponent } from "../../components/ErrorComponent";
import { GlobalContext } from "../../utils/GlobalContext";
import ProtectedComponent from "../../utils/ProtectedComponent";
import { JSXElementConstructor, ReactElement, SetStateAction, useContext, useEffect, useState } from "react";
import { ECLClientCard } from "../../components/ecl/ECLClientCard";
import { useNavigate } from "react-router-dom";
import { AuthActionLookup, ChoiceOption, Client, ClientAllergyObject, ClientComment, AuthorizationStatus, TherapistOption, PayorInfoType, authorizedBcba, VwAuthorizationDetail, VwAuthorization, APIReturnObject, Status, AuthDenialReasonLookup, AuthFeedbackLookup, ClientContact } from "../../utils/Definitions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Select, { MultiValue, OnChangeValue, SingleValue } from "react-select";
import ProtectedPage from "../../utils/ProtectedPage";
import { InputMask, type InputMaskProps, type MaskOptions } from '@react-input/mask';
import { ProfilePictureModal } from "../../components/ProfilePictureModal";
import { ModalNotification } from "../../components/ModalNotification";
import { format, zonedTimeToUtc } from 'date-fns-tz'
import { EDPNContext } from "./EDPNContext";
import { EDPNClientCard } from "../../components/edpn/EDPNClientCard";
import { ValueContainer } from "../../components/ValueContainer";
import { EDPNClientCardLearnerInfo } from "../../components/edpn/EDPNClientCardLearnerInfo";
import CreatableSelect from "react-select/creatable";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField, TextFieldProps } from "@mui/material";
import { ModalConfirm } from "../../components/ModalConfirm";
import { AuthorizationModal } from "../../components/authorizations/AuthorizationModal";
import { EDPNAuthBCBA } from "../../components/edpn/EDPNAuthBCBA";


//only renders if authenticated
const EDPNLearnerInfoContent = () => {


    const navigate = useNavigate();

    const globalContext = useContext(GlobalContext);
    const edpnContext = useContext(EDPNContext);

    // We are adding the tab functionality here as well...
    const [selectedTab, setSelectedTab] = useState<"profile" | "authorization">("profile");


    const [allergies, setAllergies] = useState<string>("");
    const [allergiesList, setAllergiesList] = useState<string[]>([]);
    const [allergiesFormatted, setAllergiesFormatted] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(true);
    const [saveAllergiesLoading, setSaveAllergiesLoading] = useState<boolean>(false);
    const [saveBCBALoading, setSaveBCBALoading] = useState<boolean>(true);
    const [saveCommentLoading, setSaveCommentLoading] = useState<boolean>(false);

    const [addAuthorizedBCBADate, setAddAuthorizedBCBADate] = useState<Date | null>(new Date());

    const [successModalActive, setSuccessModalActive] = useState<boolean>(false);

    const [errorModalActive, setErrorModalActive] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const [credentialsModalActive, setCredentialsModalActive] = useState<boolean>(false);
    const [clientComment, setClientComment] = useState<string>("");
    const [clientComments, setClientComments] = useState<ClientComment[]>([]);

    const [selectedClientForModal, setSelectedClientForModal] = useState<Client | null>(null);
    const [profilePictureModalActive, setProfilePictureModalActive] = useState<boolean>(false);
    const [commentsLoading, setCommentsLoading] = useState<boolean>(true);

    const [noLearnerInfo, setNoLearnerInfo] = useState<boolean>(true);

    const [authBCBAS, setAuthBCBAS] = useState<authorizedBcba[]>([]);
    const [selectedAuthBCBA, setSelectedAuthBCBA] = useState<ChoiceOption | null>(null);

    const [selectedDeleteAuth, setSelectedDeleteAuth] = useState<authorizedBcba | null>(null);

    const [confirmDeleteModalActive, setConfirmDeleteModalActive] = useState<boolean>(false);
    const [confirmDeleteModalMessage, setConfirmDeleteModalMessage] = useState<string>("");

    type OptionType = { value: string; label: string } | null;

    const [parentConsentTelehealth, setParentConsentTelehealth] = useState<boolean | null>(null);
    const [parentConsentTelehealthSelectedOption, setParentConsentTelehealthSelectedOption] = useState<OptionType>(null);

    //Authorization data
    const [authorization, setAuthorization] = useState<VwAuthorization | null>(null);
    const [clientAuthorizations, setClientAuthorizations] = useState<VwAuthorizationDetail[]>([]);
    const [currentClientAuthorizations, setCurrentClientAuthorizations] = useState<VwAuthorizationDetail[]>([]);
    const [pastClientAuthorizations, setPastClientAuthorizations] = useState<VwAuthorizationDetail[]>([]);

    const [authorizationStatuses, setAuthorizationStatuses] = useState<AuthorizationStatus[]>([]);
    const [payorInfoTypes, setPayorInfoTypes] = useState<PayorInfoType[]>([]);
    const [selectedClientId, setSelectedClientId] = useState<number | undefined>(undefined);
    const [selectedAuthId, setSelectedAuthId] = useState<string | null>(null);
    const [selectedAuthPayorType, setSelectedAuthPayorType] = useState<string | null>(null);
    const [isAuthorizationModalActive, setIsAuthorizationModalActive] = useState<boolean>(false);
    const [authDenialReasons, setAuthDenialReasons] = useState<AuthDenialReasonLookup[]>([]);
    const [authFeedbackOptions, setAuthFeedbackOptions] = useState<AuthFeedbackLookup[]>([]);
    const [authActions, setAuthActions] = useState<AuthActionLookup[]>([]);

    const [selectedPodManager, setSelectedPodManager] = useState<ChoiceOption | null>(null);

    // emergency contact variables
    const [emergencyRelationship, setEmergencyRelationship] = useState<ChoiceOption | null>(null);  
    const [clientRelationships, setClientRelationships] = useState<ChoiceOption[] | null>(null);
    const [emergencyContactSaveButtonActive, setEmergencyContactSaveButtonActive] = useState<boolean>(false);

    const emptyContact: ClientContact = {
        contactId: 0,
        clientId: 0,
        firstName: "",
        lastName: "",
        streetAddress: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        phoneNumber: "",
        emailAddress: "",
        contactType: "",
        relationshipId: 0
    };

    const [emergencyContact, setEmergencyContact] = useState<ClientContact>(emptyContact);

    function ProfilePictureOnCLose() {
        setSelectedClientForModal(null);
    }
    const [selectedBCBA, setSelectedBCBA] = useState<TherapistOption | null>();
    const [BCBAOptions, setBCBAOptions] = useState<TherapistOption[]>();


    function NavigateBack() {
        navigate(-1);
    }

    useEffect(() => {
        if (!edpnContext.selectedClient) {
            navigate("/edpn");
        }
    })

    useEffect(() => {
        UpdateAllergies();
        UpdateComments();
        setNoLearnerInfo(!globalContext.CheckRoles("LearnerInfoUpdate"));
        GetClientAuthorizedBCBA();
        GetClientPodManager();
        GetTelehealthGuardianConsent();
        GetClientRelationships();
        GetLearnerEmergencyContact();

        //Authorization data 
        if (globalContext.CheckRoles(["Authorizations.AppAccess", "ADMIN"])) {
            GetAuthorizationsForClient();
            GetAuthorizationStatuses();
            GetPayorInfoTypes();
            GetDenialReasons();
            GetAuthActions();
            GetAuthFeedbackOptions();
        }

    }, []);

    useEffect(() => {
        if (!selectedBCBA) {
            GetAuthorizedBCBA();
        }
    }, [BCBAOptions]);

    useEffect(() => {
        UpdateAllergiesList();
    }, [allergies]);

    useEffect(() => {
        if (globalContext.therapists) {
            const tempTherapists: TherapistOption[] = globalContext.therapists.map((therapist, index) => {
                return { value: String(therapist.therapistId), label: therapist.employeeName };
            });

            setBCBAOptions(tempTherapists);

        }
    }, [globalContext.therapists]);

    useEffect(() => {
        // Trim allergies and create a new array with trimmed values
        const trimmedAllergiesList = allergiesList.map(allergy => {
            if (typeof allergy === "string") {
                return allergy.trim();
            }
            return allergy; // If it's not a string, keep it as is
        });

        // Filter out empty strings and join the trimmed values
        const formattedAllergies = trimmedAllergiesList.filter(x => x.length > 0).join(",");

        setAllergiesFormatted(formattedAllergies);
    }, [allergiesList]);

    /*useEffect(() => {
        if (parentConsentTelehealth) {
            UpdateTelehealthGuardianConsent();
        }
    }, [parentConsentTelehealth])*/

    useEffect(() => {
        if (parentConsentTelehealth) {
            setParentConsentTelehealthSelectedOption({ value: "1", label: "Yes" });
        }
        else {
            setParentConsentTelehealthSelectedOption({ value: "0", label: "No" });
        }
    }, [parentConsentTelehealth]);

    useEffect(() => {
        if (selectedClientId) {
            setIsAuthorizationModalActive(true);
        }

    }, [selectedAuthId]);

    useEffect(() => {
        if (selectedPodManager) {
            UpdatePodManager();
        }
    }, [selectedPodManager]);

    useEffect(() => {
        if (emergencyContact) {
            // need to update the dropdown value
            PopulateRelationshipDropdownOnLoad();
            CheckEmergencyContactButton();
        }
    }, [emergencyContact]);

    function PopulateRelationshipDropdownOnLoad() {
        if (emergencyContact && emergencyContact.relationshipId) {
            var relationship = clientRelationships?.find(x => x.value === emergencyContact.relationshipId?.toString());

            if (relationship) {
                var temp: ChoiceOption = ({ value: String(relationship.value), label: String(relationship.label) });
                setEmergencyRelationship(temp);
            }
        }
    }

    useEffect(() => {
        if (clientAuthorizations) {
            // Filter and sort by reportDueDate
            const tempCurrentAuths = clientAuthorizations
                .filter(x => x.authActive && new Date(x.reportDueDate) >= new Date())
                .sort((a, b) => new Date(a.reportDueDate).getTime() - new Date(b.reportDueDate).getTime());

            const tempPastAuths = clientAuthorizations
                .filter(x => new Date(x.reportDueDate) <= new Date())
                .sort((a, b) => new Date(a.reportDueDate).getTime() - new Date(b.reportDueDate).getTime());

            setCurrentClientAuthorizations(tempCurrentAuths);
            setPastClientAuthorizations(tempPastAuths);
        }
    }, [clientAuthorizations]);

    const HandleAuthorizationClick = (authId: string, authPayorType: string, clientId: number) => {
        setSelectedAuthId(authId);
        setSelectedAuthPayorType(authPayorType);
        setSelectedClientId(clientId);
    }

    const OnModalClose = () => {
        ClearValues();
    }

    function ClearValues() {
        setSelectedClientId(undefined);
        setSelectedAuthId(null);
        setSelectedAuthPayorType(null);
        setSelectedClientForModal(null);
        setIsAuthorizationModalActive(false);
    }

    function UpdateAllergiesList() {
        var temp: string[] = allergies.split(",");
        setAllergiesList(temp);
    }

    function UpdateAllergies() {

        if (edpnContext.selectedClient) {
            globalContext.GetToken().then((token: any) => {

                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };

                var url = apiConfig.apiEndpoint + "/EDPN/GetLearnerAllergies?clientID=" + edpnContext.selectedClient?.clientId;

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            setAllergies(result);
                        },
                        (error) => {
                            setLoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/GetLearnerAllergies" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }
    }

    function GetAuthorizationStatuses() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthorizationStatuses";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthorizationStatuses(result);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthorizationStatuses" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetPayorInfoTypes() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetPayorInfoTypes";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setPayorInfoTypes(result);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetPayorInfoTypes" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetDenialReasons() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthDenialReasonLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthDenialReasons(result);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthDenialReasonLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthFeedbackOptions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthFeedbackLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthFeedbackOptions(result);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthFeedbackLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetAuthActions() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");

            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthActionLookup";
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setAuthActions(result);
                        setLoading(false);
                    },
                    (error) => {
                        //setLoading(false);
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthActionLookup" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function AddComment() {
        globalContext.GetToken().then((token: any) => {

            if (edpnContext && edpnContext.selectedClient && edpnContext.selectedClient.clientId && globalContext.CoreAccount.currentUser) {


                var commentObject: ClientComment = {
                    clientId: edpnContext.selectedClient.clientId,
                    billingDate: new Date(new Date().toLocaleString() + " +0000"),
                    comment: clientComment,
                    createdOn: new Date(new Date().toLocaleString() + " +0000"),
                    createdBy: globalContext.CoreAccount.currentUser.name,
                    refId: null,
                };

                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");

                var options = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(commentObject)
                };

                //debug size in kb
                const size = new TextEncoder().encode(JSON.stringify(commentObject)).length
                const kiloBytes = size / 1024;
                console.log("size:" + kiloBytes + " kb ", commentObject);

                var url = apiConfig.apiEndpoint + "/Clients/AddComment";

                setSaveCommentLoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            if (result == true) {
                                console.log("success adding comment");
                                setClientComment("");
                                UpdateComments();
                                setSaveCommentLoading(false);
                            }
                            else {
                                setSaveCommentLoading(false);

                                globalContext.setErrorModalProps({ errorMessage: "Failed to add comment. Unknown error.", errorLocation: "/Clients/AddComment" });
                                globalContext.setErrorModalActive(true);
                            }
                        },
                        (error) => {
                            setErrorMessage(error);
                            setErrorModalActive(true);
                        }
                    )

            }
        })

    }

    function UpdateComments() {
        if (edpnContext.selectedClient && edpnContext.selectedClient.clientId) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };

                var url = apiConfig.apiEndpoint + "/Clients/GetCommentsByDate?clientID=" + edpnContext.selectedClient?.clientId + "&date=" + new Date(new Date().toLocaleString() + " +0000").toISOString();

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            console.log("raw result:", result);
                            setClientComments(result);
                            setCommentsLoading(false);
                        },
                        (error) => {
                            setCommentsLoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetCommentsByDate" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }

    }

    // This will need to be called when the pod manager value changes
    function UpdatePodManager() {
        //this fires on change, so we check to make sure its actually updating to avoid saving on page load
        if (edpnContext.selectedClient && edpnContext.selectedClient.clientId && selectedPodManager && String(selectedPodManager.value) != String(edpnContext.selectedClient.podmanager)) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "POST",
                    headers: headers
                };
                
                var url = apiConfig.apiEndpoint + "/Clients/UpdatePodManager?clientID=" + edpnContext.selectedClient?.clientId + "&podManagerID=" + selectedPodManager?.value;

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            edpnContext.UpdateAllClients(); //update clients so if you reload from EDPN home, it will have correct values
                            edpnContext.setSelectedClient(prev => prev ? { ...prev, podmanager: Number(selectedPodManager?.value) } : prev); //update pod manager

                            globalContext.setToastMessage("Saved Pod Manager successfully!");
                            globalContext.setToastIcon("Success");
                            globalContext.setToastActive(true);
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/UpdatePodManager" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }

    }

    function GetAuthorizedBCBA() {
        if (edpnContext.selectedClient && edpnContext.selectedClient.clientId) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };

                var url = apiConfig.apiEndpoint + "/Clients/GetAuthorizedBCBA?clientID=" + edpnContext.selectedClient?.clientId;

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            console.log("raw authorized bcba:", result);

                            SelectAuthorizedBCBA(result);
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }

    }

    function SelectAuthorizedBCBA(BCBA: string) {
        var foundBCBA = BCBAOptions?.find(x => x.label.toLowerCase() == BCBA.toLowerCase());

        if (foundBCBA) {
            setSelectedBCBA(foundBCBA);
        }
        else {
            var tempBCBAOptions = BCBAOptions;

            if (tempBCBAOptions) {

                var tempBCBA: TherapistOption = {
                    value: BCBA,
                    label: BCBA
                };

                tempBCBAOptions.push(tempBCBA);

                tempBCBAOptions = tempBCBAOptions.sort((a, b) => a.label < b.label ? -1 : 1);

                setBCBAOptions(tempBCBAOptions);
                setSelectedBCBA(tempBCBA);
            }

        }

    }

    function UpdateAuthBCBA(bcba: authorizedBcba) {
        if (bcba) {

            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");


                var options = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(bcba)
                };

                var url = apiConfig.apiEndpoint + "/Clients/UpdateAuthorizedBCBA";

                setSaveBCBALoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result: APIReturnObject) => {
                            if (result.status === Status.SUCCESS) {
                                GetClientAuthorizedBCBA();
                                setSaveBCBALoading(false);

                            }
                            else if (result.status === Status.FAIL) {
                                globalContext.setNotificationModalMessage("Cannot save authorized bcba. " + result.message);
                                globalContext.setNotificationModalActive(true);
                                setSaveBCBALoading(false);

                            }
                            else if (result.status === Status.ERROR) {
                                globalContext.setErrorModalProps({ errorMessage: "Failed to save authorized bcba. " + result.message, errorLocation: "/EDPN/UpdateAuthorizedBCBA" });
                                globalContext.setErrorModalActive(true);
                                setSaveBCBALoading(false);

                            }
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/UpdateAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                            setSaveBCBALoading(false);

                        }
                    )
            })




        }
    }

    function SaveAllergies() {

        setSaveAllergiesLoading(true);


        if (edpnContext.selectedClient && edpnContext.selectedClient.clientId) {
            globalContext.GetToken().then((token: any) => {


                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");


                var finalAnswerObject: ClientAllergyObject = {
                    clientID: edpnContext.selectedClient?.clientId,
                    allergies: allergiesFormatted
                };

                var options = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(finalAnswerObject)
                };

                var url = apiConfig.apiEndpoint + "/EDPN/UpdateLearnerAllergies";

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            if (result == true) {
                                UpdateAllergies();
                                setSuccessModalActive(true);
                                setSaveAllergiesLoading(false);
                            }
                            else {
                                globalContext.setErrorModalProps({ errorMessage: "Failed to save allergies. Unknown error.", errorLocation: "/EDPN/UpdateLearnerAllergies" });
                                globalContext.setErrorModalActive(true);
                                setSaveAllergiesLoading(false);

                            }
                        },
                        (error) => {
                            setLoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/UpdateLearnerAllergies" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }


    }

    function UpdateTelehealthGuardianConsent(hasConsent: boolean) {
        if (edpnContext.selectedClient) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "POST",
                    headers: headers
                };

                var url = apiConfig.apiEndpoint + "/EDPN/SetTeleHealthParentConsent?clientID=" + edpnContext.selectedClient?.clientId + "&hasConsent=" + hasConsent;

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }
    }

    function GetTelehealthGuardianConsent() {
        if (edpnContext.selectedClient) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };

                var url = apiConfig.apiEndpoint + "/EDPN/GetTeleHealthParentConsent?clientID=" + edpnContext.selectedClient?.clientId;

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            setParentConsentTelehealth(result);
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }
    }

    function GetAuthorizationsForClient() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            headers.append("Content-type", "application/json;charset=UTF-8");


            var options = {
                method: "GET",
                headers: headers,
            };

            var url = apiConfig.apiEndpoint + "/Credentials/GetAuthorizationDetailsForClient?clientId=" + edpnContext.selectedClient?.clientId;
            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setClientAuthorizations(result);
                    },
                    (error) => {
                        setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetAuthorizationDetailsForClient" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }

    function GetClientRelationships() {
        globalContext.GetToken().then((token: any) => {

            if (globalContext.CoreAccount.roles.includes('ADMIN') || globalContext.CoreAccount.roles.includes('Administration.Learner.Write')) {

                var headers = new Headers();

                var bearer = "Bearer " + token;

                headers.append("Authorization", bearer);
                var options = {
                    method: "GET",
                    headers: headers
                };

                fetch(apiConfig.apiEndpoint + "/Clients/GetClientRelationships", options)
                    .then(res => res.json())
                    .then(
                        (result) => {

                            const mappedRelationships: ChoiceOption[] = result.map((relationship: any) => ({
                                value: relationship.relationshipId.toString(),  // Assuming RelationshipId is a number, convert to string if needed
                                label: relationship.description
                            }));

                            setClientRelationships(mappedRelationships);

                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetClientRelationships" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            }
        })
    }

    function UpdateClientEmergencyContact() {
        if (edpnContext.selectedClient && emergencyContact.firstName && emergencyContact.lastName && emergencyContact.relationshipId && emergencyContact.phoneNumber && emergencyContact.emailAddress) {

            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                var options = {
                    method: "POST",
                    headers: headers
                };

                // exchange this with the real url later.
                var url = apiConfig.apiEndpoint + "/Clients/UpdateLearnerEmergencyContact?firstName=" + emergencyContact.firstName + "&lastName=" + emergencyContact.lastName + "&relationshipId=" + emergencyContact.relationshipId + "&phoneNumber=" + emergencyContact.phoneNumber + "&email=" + emergencyContact.emailAddress + "&clientId=" + edpnContext.selectedClient?.clientId;

                setLoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result: APIReturnObject) => {
                            if (result.status === Status.SUCCESS) {
                                setLoading(false);

                                globalContext.setToastMessage("Emergency Contact Updated.");
                                globalContext.setToastIcon("Success");
                                globalContext.setToastActive(true);

                            }
                            else if (result.status === Status.FAIL) {
                                setLoading(false);
                                globalContext.setNotificationModalMessage(result.message);
                                globalContext.setNotificationModalActive(true);
                            }
                            else if (result.status === Status.ERROR) {
                                setLoading(false);
                                globalContext.setErrorModalProps({ errorMessage: result.message, errorLocation: "/Clients/UpdateLearnerEmergencyContact" });
                                globalContext.setErrorModalActive(true);
                            }
                        },
                        (error) => {
                            setLoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/UpdateLearnerEmergencyContact" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }
    }

    function GetLearnerEmergencyContact() {
        if (edpnContext.selectedClient) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");

                var options = {
                    method: "GET",
                    headers: headers,
                };

                var url = apiConfig.apiEndpoint + "/Clients/GetLearnerEmergencyContact?clientId=" + edpnContext.selectedClient?.clientId;
                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            setEmergencyContact(result);
                        },
                        (error) => {
                            setLoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetLearnerEmergencyContact" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })

        }
    }

    function OnRelationshipDDChange(input: SingleValue<ChoiceOption>) {
        if (clientRelationships) {
            var foundRelationship = clientRelationships?.find(z => String(z.value) === String(input?.value));

            if (foundRelationship) {
                setEmergencyRelationship(foundRelationship);

                // set the relationship id for the object
                setEmergencyContact(prev => ({ ...prev, relationshipId: Number(input?.value) }))
            }
            else {
                setEmergencyRelationship(null);
                setEmergencyContact(prev => ({ ...prev, relationshipId: null }))
            }
        }
    }

    function CheckEmergencyContactButton() {
        const isNonEmpty = (s?: string | null) => ((s ?? "").trim().length > 0);

        const hasName = isNonEmpty(emergencyContact?.firstName) && isNonEmpty(emergencyContact?.lastName);
        const hasRelationship = emergencyContact?.relationshipId != null && emergencyContact.relationshipId !== 0;
        const phoneDigits = (emergencyContact?.phoneNumber ?? "").replace(/\D/g, "");
        const hasPhone = phoneDigits.length >= 10; // require 10+ digits
        const email = (emergencyContact?.emailAddress ?? "").trim();
        const hasEmail = email.length > 0 && /\S+@\S+\.\S+/.test(email);

        const isValid = !!emergencyContact && hasName && hasRelationship && hasPhone && hasEmail;
        setEmergencyContactSaveButtonActive(isValid);
    }


    function AddLine() {
        var tempanswers: string[] = [];

        for (var i = 0; i < allergiesList.length; i++) {
            tempanswers.push(allergiesList[i]);
        }

        //new line
        tempanswers.push("");

        setAllergiesList(tempanswers);
    }

    function RemoveLine() {
        if (allergiesList.length > 1) {
            var tempanswers: string[] = [];

            for (var i = 0; i < allergiesList.length; i++) {
                tempanswers.push(allergiesList[i]);
            }

            //remove line
            tempanswers.pop();

            setAllergiesList(tempanswers);
        }
    }


    function UpdateAnswers(index: number, value: string) {

        var tempanswers: string[] = [];

        for (var i = 0; i < allergiesList.length; i++) {
            if (i != index) {
                tempanswers.push(allergiesList[i]);
            }
            else {
                tempanswers.push(value);
            }
        }
        setAllergiesList(tempanswers);
    }

    function SuccessModalClose() {

    }

    function GetTherapistNameByID(id: string | undefined): string {
        if (globalContext.therapists) {
            var therapist = globalContext.therapists.find(x => x.therapistId == (id ? parseInt(id) : undefined));
            if (therapist) {
                return therapist.employeeName;
            } else if (id === "-1") {
                return String(id);
            } else {
                return String(id);
            }
        } else {
            return String(id);
        }
    }

    function OnChange(input: SingleValue<TherapistOption>) {
        var finalOption: TherapistOption | null = null;

        if (BCBAOptions && input) {
            var foundOption = BCBAOptions.find(z => z.value == input.value);
            if (foundOption) {
                finalOption = foundOption;
            }
            else {

                var CustomChoice: ChoiceOption = {
                    value: input.value,
                    label: input.label
                };

                finalOption = CustomChoice;
            }

            setSelectedBCBA(finalOption);
        }

    }

    function AddAuthBCBA() {
        if (selectedAuthBCBA && selectedAuthBCBA.label && addAuthorizedBCBADate && edpnContext.selectedClient && edpnContext.selectedClient.clientId) {

            var authorizedBcba: authorizedBcba = {
                therapistId: Number(selectedAuthBCBA.value),
                clientId: edpnContext.selectedClient.clientId,
                effectiveStart: addAuthorizedBCBADate,
                active: true,
                authorizedBcbaid: null
            };


            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");


                var options = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(authorizedBcba)
                };

                var url = apiConfig.apiEndpoint + "/Clients/UpdateAuthorizedBCBA";

                setSaveBCBALoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result: APIReturnObject) => {
                            if (result.status === Status.SUCCESS) {
                                GetClientAuthorizedBCBA();
                                setSelectedAuthBCBA(null);
                                setSaveBCBALoading(false);
                            }
                            else if (result.status === Status.FAIL) {
                                globalContext.setNotificationModalMessage("Cannot save authorized bcba. " + result.message);
                                globalContext.setNotificationModalActive(true);
                                setSaveBCBALoading(false);
                            }
                            else if (result.status === Status.ERROR) {
                                globalContext.setErrorModalProps({ errorMessage: "Failed to save authorized bcba. " + result.message, errorLocation: "/EDPN/UpdateAuthorizedBCBA" });
                                globalContext.setErrorModalActive(true);
                                setSaveBCBALoading(false);
                            }
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/UpdateAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                            setSaveBCBALoading(false);
                        }
                    )
            })




        }

    }

    function DeleteAuth() {
        if (selectedDeleteAuth) {

            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");


                var options = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(selectedDeleteAuth)
                };

                var url = apiConfig.apiEndpoint + "/Clients/DeleteClientAuthorizedBCBA";

                setSaveBCBALoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result: APIReturnObject) => {
                            if (result.status === Status.SUCCESS) {
                                GetClientAuthorizedBCBA();
                                setSelectedAuthBCBA(null);
                                setSaveBCBALoading(false);
                            }
                            else if (result.status === Status.FAIL) {
                                globalContext.setNotificationModalMessage("Cannot delete authorized bcba. " + result.message);
                                globalContext.setNotificationModalActive(true);
                                setSaveBCBALoading(false);
                            }
                            else if (result.status === Status.ERROR) {
                                globalContext.setErrorModalProps({ errorMessage: "Failed to delete authorized bcba. " + result.message, errorLocation: "/EDPN/DeleteClientAuthorizedBCBA" });
                                globalContext.setErrorModalActive(true);
                                setSaveBCBALoading(false);
                            }
                        },
                        (error) => {
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/DeleteClientAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                            setSaveBCBALoading(false);
                        }
                    )
            })




        }

    }

    function GetClientPodManager() {
        if (edpnContext.selectedClient && edpnContext.selectedClient.podmanager) {
            var foundPodManager = globalContext.bcbas.find(x => x.therapistId === edpnContext.selectedClient?.podmanager);

            if (foundPodManager) {
                var temp: ChoiceOption = ({ value: String(foundPodManager.therapistId), label: String(foundPodManager.employeeName) });
                setSelectedPodManager(temp);
            }

        }
    }

    function GetClientAuthorizedBCBA() {

        if (edpnContext.selectedClient && edpnContext.selectedClient.clientId) {
            globalContext.GetToken().then((token: any) => {
                var headers = new Headers();
                var bearer = "Bearer " + token;
                headers.append("Authorization", bearer);
                headers.append("Content-type", "application/json;charset=UTF-8");


                var options = {
                    method: "GET",
                    headers: headers,
                };

                var url = apiConfig.apiEndpoint + "/Clients/GetClientAuthorizedBCBA?clientid=" + edpnContext.selectedClient?.clientId;
                setSaveBCBALoading(true);

                fetch(url, options)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            setAuthBCBAS(result);
                            setSaveBCBALoading(false);
                        },
                        (error) => {
                            setLoading(false);
                            setSaveBCBALoading(false);
                            globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Clients/GetClientAuthorizedBCBA" });
                            globalContext.setErrorModalActive(true);
                        }
                    )
            })
        }
    }

    function formatPhoneNumber(phoneNumber: string | number | null | undefined): string {
        if (!phoneNumber) return "";
        const numStr = phoneNumber.toString();
        return numStr.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }

    function OnClickDeleteAuth(Auth: authorizedBcba) {
        setSelectedDeleteAuth(Auth);
        setConfirmDeleteModalMessage("<div>Are you sure you want to delete the authorized bcba for this Patient:</div><div>" + GetTherapistNameByID(String(Auth.therapistId)) + "?</div>");
        setConfirmDeleteModalActive(true);
    }

    const SaveAllergiesButton = () => {

        if (saveAllergiesLoading) {
            return (
                <button disabled={true} className="m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white bg-lacgreen-600">
                    <FontAwesomeIcon className="fill-current text-white w-5 h-5 animate-spin align-middle" icon={solid('spinner')} />
                    <span className="drop-shadow align-middle pl-1">Processing</span>
                </button>
            );
        }
        else {
            return (<button disabled={noLearnerInfo} onClick={SaveAllergies} className={"bg-lacgreen m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacgreen-600 " + (noLearnerInfo ? 'bg-lacgreen-600' : 'cursor-pointer')}><span className="drop-shadow">Save Allergies</span></button>)
        }
    }

    const AddAuthorizedBCBAButton = () => {

        if (saveBCBALoading) {
            return (
                <button disabled={true} className="m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white bg-lacgreen-600">
                    <FontAwesomeIcon className="fill-current text-white w-5 h-5 animate-spin align-middle" icon={solid('spinner')} />
                    <span className="drop-shadow align-middle pl-1">Processing</span>
                </button>
            );
        }
        else {
            return (<button disabled={noLearnerInfo || addAuthorizedBCBADate == null || selectedAuthBCBA == null} onClick={AddAuthBCBA} className={"bg-lacgreen m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacgreen-600 " + (noLearnerInfo || addAuthorizedBCBADate == null || selectedAuthBCBA == null ? 'bg-lacgreen-600' : 'cursor-pointer')}><span className="drop-shadow">Add</span></button>)
        }
    }

    const AddCommentButton = () => {
        if (saveCommentLoading) {
            return (
                <button disabled={true} className="m-auto w-[8rem] xl:w-[8rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white bg-lacgreen-600">
                    <FontAwesomeIcon className="fill-current text-white w-5 h-5 animate-spin align-middle" icon={solid('spinner')} />
                    <span className="drop-shadow align-middle pl-1">Processing</span>
                </button>
            );
        }
        else {
            return (<button disabled={clientComment.length == 0} onClick={AddComment} className={"bg-lacgreen m-auto w-[10rem] xl:w-[10rem] h-[2rem] xl:h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacgreen-600 " + (clientComment.length > 0 ? '' : 'bg-lacgreen-600')}><span className="drop-shadow">Add Comment</span></button>)
        }
    }

    const ClientCard = () => {

        if (edpnContext.selectedClient) {
            return (
                <EDPNClientCardLearnerInfo Client={edpnContext.selectedClient} SetProfilePictureModalActive={setProfilePictureModalActive} SetSelectedClientForModal={setSelectedClientForModal} SetCredentialsModalActive={setCredentialsModalActive} />
            )
        }
        else {
            return <></>
        }

    }

    return (

        <div className="grid grid-rows-auto ml-auto mr-auto">

            <div className="grid grid-cols-1 h-fit mt-0 mb-8">

                <div className="grid grid-flow-row">

                    <div className="grid grid-cols-1 mt-4 gap-4 content-between xl:w-fit xl:m-auto">

                        <div onClick={NavigateBack} className="my-2 mb-8 flex items-center justify-center w-40 cursor-pointer">
                            <div className="flex-1">
                                <FontAwesomeIcon className="w-8 h-8 mr-auto align-middle" icon={solid('arrow-left')} />
                            </div>
                            <span className="text-xl w-auto ml-3">Back</span>
                            <div className="flex-1"></div>
                        </div>


                        <ClientCard />

                        <div className={"w-full m-auto mt-4 " + (saveBCBALoading ? '' : 'hidden')}>
                            <div className="w-full h-auto flex">
                                <FontAwesomeIcon className="fill-current text-lacblue w-24 h-24 animate-spin m-auto" icon={solid('spinner')} />
                            </div>
                        </div>

                        {/*Tab div here*/}
                        <div className={" w-full m-auto col-span-12 " + (saveBCBALoading ?? "hidden")}>

                            <button onClick={() => setSelectedTab("profile")} className={"block hover:text-lacblue mr-4 transition duration-250 ease-in-out mt-4 inline-block mt-0 text-xl " + (selectedTab == "profile" ? "text-lacblue border-b-2 border-lacblue font-bold " : "")}>
                                <FontAwesomeIcon className="fill-current text-xl cursor-pointer mr-2" icon={solid('circle-user')} />
                                Profile
                            </button>

                            {/*Authorizations.InsuranceAccess*/}
                            {/* TEMP: Authorization tab navigation disabled
                            <ProtectedComponent RequiredRoles={["Authorizations.AppAccess"]}>
                                <button onClick={() => setSelectedTab("authorization")} className={"block hover:text-lacblue mr-4 transition duration-250 ease-in-out mt-4 inline-block mt-0 text-xl " + (selectedTab == "authorization" ? "text-lacblue border-b-2 border-lacblue font-bold " : "")}>
                                    <FontAwesomeIcon className="fill-current text-xl cursor-pointer mr-2" icon={solid('clipboard-check')} />
                                    Authorization
                                </button>
                            </ProtectedComponent>
                            */}

                        </div>

                        <div className={"w-full m-auto col-span-12 " + (selectedTab == "profile" ? "" : "hidden")}>
                            <div className={"w-full m-auto mt-4 " + (saveBCBALoading ? 'hidden' : '')}>
                                <div className="w-full m-auto mt-4 col-span-12">
                                    <label className="block font-bold">Authorized Provider History:</label>

                                    {/* Check if authBCBAS is empty */}
                                    {authBCBAS && authBCBAS.length === 0 && (
                                        <div className="text-red-500">No authorized provider history</div>
                                    )}

                                    {/* Map through authBCBAS if not empty */}
                                    {authBCBAS && authBCBAS.map((bcba, index) => (
                                        <EDPNAuthBCBA
                                            key={index}
                                            bcba={bcba}
                                            noLearnerInfo={noLearnerInfo}
                                            UpdateAuthBCBA={UpdateAuthBCBA}
                                            OnClickDeleteAuth={OnClickDeleteAuth}
                                        />
                                    ))}


                                    {/* New Record Input Boxes */}
                                    <div className="grid grid-cols-3 gap-4 mt-2 border-2 border-lacgreen p-2">
                                        {/* Input Box 1 for New Record */}
                                        <label className="block font-bold">New Authorized Provider:</label>
                                        <label className="block font-bold">New Start Date:</label>
                                        <div></div>
                                        <Select
                                            isDisabled={noLearnerInfo}
                                            className=""
                                            components={{ ValueContainer }}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={globalContext.bcbas.map((therapist) => ({ value: String(therapist.therapistId), label: therapist.employeeName }))}
                                            onChange={setSelectedAuthBCBA}
                                            value={selectedAuthBCBA} />

                                        {/* Input Box 2 for New Record */}
                                        <DatePicker
                                            disabled={noLearnerInfo}
                                            value={addAuthorizedBCBADate}
                                            onChange={setAddAuthorizedBCBADate}
                                            renderInput={(params) => <TextField size="small" {...params} />}
                                        />


                                        <AddAuthorizedBCBAButton />
                                    </div>
                                </div>
                            </div>

                            {/*Put emergency contact info here*/}
                            {/* Commenting out so it can possibly be used later */}
                            {/*<div className="grid grid-cols-3 gap-4">

                                <div className="w-full grid-cols-1 m-auto mt-2">
                                    <label className="block font-bold">Emergency Contact Name:</label>
                                    <input
                                        maxLength={255}
                                        autoComplete="off"
                                        type="text"
                                        value={emergencyContactName ?? ""}
                                        onChange={(event) => setEmergencyContactName(event.target.value)}
                                        className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                    />
                                    
                                </div>

                                */}{/* Telehealth Consent */}{/*
                                <div className="grid-cols-1 w-full m-auto mt-2">

                                    <label className="block font-bold">Emergency Contact Email:</label>
                                    <input
                                        maxLength={255}
                                        autoComplete="off"
                                        type="text"
                                        value={emergencyContactEmail ?? ""}
                                        onChange={(event) => setEmergencyContactEmail(event.target.value)}
                                        className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                    />
                                    
                                </div>
                            </div>*/}

                            {/*<div className="w-full my-6 border-2 border-lacblue p-2">
                                */}{/* Title */}{/*
                                <h2 className="text-lg font-bold mb-4 text-left">Emergency Contact</h2>

                                */}{/* Form Grid */}{/*
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                    */}{/* First Name */}{/*
                                    <div>
                                        <label className="block font-bold mb-1">First Name</label>
                                        <input
                                            maxLength={30}
                                            type="text"
                                            value={emergencyContact?.firstName ?? ""}
                                            onChange={(e) =>
                                                setEmergencyContact(prev => ({ ...prev, firstName: e.target.value }))
                                            }
                                            className="outline-none h-[38px] border border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                        />
                                    </div>

                                    */}{/* Last Name */}{/*
                                    <div>
                                        <label className="block font-bold mb-1">Last Name</label>
                                        <input
                                            maxLength={30}
                                            type="text"
                                            value={emergencyContact?.lastName ?? ""}
                                            onChange={(e) => setEmergencyContact(prev => ({ ...prev, lastName: e.target.value }))}
                                            className="outline-none h-[38px] border border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                        />
                                    </div>

                                    */}{/* Relationship */}{/*
                                    <div className="lg:col-span-2">
                                        <label className="block font-bold mb-1">Relationship</label>
                                        <Select
                                            isClearable={true}
                                            onChange={OnRelationshipDDChange}
                                            value={emergencyRelationship}
                                            options={clientRelationships ?? undefined}
                                        />
                                    </div>

                                    */}{/* Phone */}{/*
                                    <div>
                                        <label className="block font-bold mb-1">Phone</label>
                                        <InputMask
                                            mask="(___)-___-____"
                                            replacement={{ _: /\d/ }}
                                            name="primaryContactPhoneNumber"
                                            value={formatPhoneNumber(emergencyContact?.phoneNumber) ?? ""}
                                            onChange={(e) => setEmergencyContact(prev => ({ ...prev, phoneNumber: e.target.value }))}
                                            className="outline-none h-[38px] border border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                            placeholder="(123) 456-7890"
                                        />
                                    </div>

                                    */}{/* Email (starts a second row on large screens) */}{/*
                                    <div className="lg:col-span-2">
                                        <label className="block font-bold mb-1">Email</label>
                                        <input
                                            maxLength={65}
                                            type="email"
                                            value={emergencyContact?.emailAddress ?? ""}
                                            onChange={(e) => setEmergencyContact(prev => ({ ...prev, emailAddress: e.target.value }))}
                                            className="outline-none h-[38px] border border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue w-full p-2.5"
                                        />
                                    </div>

                                    */}{/* Save button */}{/*
                                    <div className="flex items-end">
                                        */}{/*<button
                                            disabled={!emergencyContactSaveButtonActive}
                                            onClick={() => { UpdateClientEmergencyContact(); }}
                                            className="bg-lacgreen w-[8rem] h-[38px] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacgreen-600"
                                        >
                                            <span className="drop-shadow">Save</span>
                                        </button>*/}{/*

                                        <button
                                            onClick={() => { UpdateClientEmergencyContact(); }}
                                            className={
                                                "bg-lacgreen w-[8rem] h-[38px] rounded font-bold text-lg text-white transition duration-250 ease-in-out " +
                                                (emergencyContactSaveButtonActive
                                                    ? 'hover:bg-lacgreen-600'
                                                    : 'opacity-50 cursor-not-allowed')
                                            }
                                            disabled={!emergencyContactSaveButtonActive}
                                        >
                                            {loading ? (
                                                <FontAwesomeIcon
                                                    className="fill-current text-white w-5 h-5 animate-spin m-auto"
                                                    icon={solid('spinner')}
                                                />
                                            ) : (
                                                <span className="drop-shadow">Save</span>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>*/}


                            <div className="grid grid-cols-2 gap-4">

                                <div className="w-full grid-cols-1 m-auto mt-2">
                                    <label className="block font-bold">Pod Manager:</label>

                                    <Select
                                        isDisabled={noLearnerInfo}
                                        className=""
                                        components={{ ValueContainer }}
                                        isMulti={false}
                                        closeMenuOnSelect={true}
                                        options={globalContext.bcbas.map((therapist) => ({ value: String(therapist.therapistId), label: therapist.employeeName }))}
                                        onChange={setSelectedPodManager}
                                        value={selectedPodManager} />
                                </div>

                                {/* Telehealth Consent */}
                                <div className="grid-cols-1 w-full m-auto mt-2">

                                    <label className="block font-bold">Does guardian consent to telehealth?:</label>

                                    <Select
                                        isDisabled={noLearnerInfo}
                                        className=""
                                        components={{ ValueContainer }}
                                        isMulti={false}
                                        closeMenuOnSelect={true}
                                        options={[
                                            { value: "1", label: "Yes" },
                                            { value: "0", label: "No" }
                                        ]}
                                        onChange={(newValue) => {
                                            if (newValue) {

                                                setParentConsentTelehealthSelectedOption(newValue);
                                                const boolValue = newValue.value === "1";

                                                UpdateTelehealthGuardianConsent(boolValue);

                                            }
                                            else {
                                                setParentConsentTelehealthSelectedOption(null);
                                            }
                                        }}
                                        value={parentConsentTelehealthSelectedOption}
                                    />
                                </div>
                            </div>


                            <div className="w-full m-auto mt-4">

                                <label className="block font-bold">Allergies:</label>

                                {Array.from(Array(allergiesList.length), (e, i) => {
                                    return <input disabled={noLearnerInfo} key={i} onChange={e => UpdateAnswers(i, e.target.value)} value={allergiesList[i]} autoComplete="off" type="text" className="mb-2 outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full p-2.5" />
                                })}

                                <button disabled={noLearnerInfo} onClick={AddLine} className={"bg-lacblue m-auto w-[8rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacblue-600 noprint " + (noLearnerInfo ? 'bg-lacblue-600' : 'cursor-pointer')}><span className="drop-shadow">Add Allergy</span></button>
                                <button disabled={allergiesList.length == 1 || noLearnerInfo} onClick={RemoveLine} className={"bg-rose m-auto ml-2 w-[8rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-rose-600 noprint " + (allergiesList.length == 1 || noLearnerInfo ? 'bg-rose-600' : 'cursor-pointer')}><span className="drop-shadow">Remove</span></button>

                            </div>

                            <div>
                                <SaveAllergiesButton />
                            </div>

                            <div className="w-full mt-12">

                                <div className="w-full border-2">
                                    <span className="font-bold">Comments:</span>
                                    <table className="border-separate border-spacing-3">
                                        <tbody>
                                            {clientComments ? clientComments.map(comment => <tr key={comment.dpncommentId}><td>[{comment.createdOn ? format(new Date(comment.createdOn), 'M/d/yy') : ""}]</td><td>{comment.createdBy}: </td><td>{comment.comment}</td></tr>) : <></>}
                                            {clientComments.length == 0 && <tr><td className="text-rose">No Comments Today.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>

                                <label className="block font-bold mt-2">
                                    Add Comment:
                                </label>
                                <input maxLength={250} autoComplete="off" type="text" value={clientComment} onChange={(event) => setClientComment(event.target.value)} className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full p-2.5" />

                                <div className="mt-2">
                                    <AddCommentButton />

                                </div>


                            </div>
                            {/* End Tab div here*/}
                        </div>

                        <div className={"w-full m-auto col-span-12 " + (selectedTab == "authorization" ? "" : "hidden")}>
                            <div className="ml-auto p-2 border-2 border-lacblue rounded-lg">

                                <div className="w-full flex my-1 items-center">
                                    <h2 className="text-2xl text-lacblue w-fit">Current Authorization</h2>
                                </div>

                                <div className="max-h-96 overflow-y-auto">
                                    <table className="table-auto w-full">
                                        <thead className="w-full border border-lacblue-500">
                                            <tr className="bg-lacblue text-white">
                                                <th>Code</th>
                                                <th>Mod 1</th>
                                                <th>Mod 2</th>
                                                <th>Hours Apv.</th>
                                                <th>Util %</th>
                                                <th>Authorized BCBA</th>
                                                <th>Payor</th>
                                                <th>Payor Type</th>
                                                <th>Bucket Info</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Report Due</th>
                                                <th>Auth Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Build out dependent on the view */}

                                            {currentClientAuthorizations && currentClientAuthorizations.length > 0 ? currentClientAuthorizations.map(authorization =>
                                                <tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2"><span>{authorization.cptcode}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.mod1 ? authorization.mod1 : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.mod2 ? authorization.mod2 : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.hoursAllowed ? authorization.hoursAllowed : "N/A"}</span></td>
                                                    <td className={"border border-gray-500 p-2 " + (authorization.proratedPercentageUtilized ? (authorization.proratedPercentageUtilized >= 90 && authorization.proratedPercentageUtilized <= 104) ? "bg-lacgreen-200" : "bg-rose-200" : "")}><span>{authorization.proratedPercentageUtilized ? authorization.proratedPercentageUtilized : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.providerName ? authorization.providerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorName ? authorization.payorName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorInfoType ? authorization.payorInfoType : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.bucket ? "Bucket" : "Non-Bucket"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.startDate ? new Date(authorization.startDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.endDate ? new Date(authorization.endDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.reportDueDate ? new Date(authorization.reportDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.status}</span></td>
                                                    <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                </tr>
                                            ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                            <div className="ml-auto mt-2 p-2 border-2 border-lacblue rounded-lg">

                                <div className="w-full flex my-1 items-center">
                                    <h2 className="text-2xl text-lacblue w-fit">Past Authorizations</h2>
                                </div>

                                <div className="max-h-96 overflow-y-auto">
                                    <table className="table-auto w-full">
                                        <thead className="w-full border border-lacblue-500">
                                            <tr className="bg-lacblue text-white">
                                                <th>Code</th>
                                                <th>Mod 1</th>
                                                <th>Mod 2</th>
                                                <th>Hours Apv.</th>
                                                <th>Util %</th>
                                                <th>Authorized BCBA</th>
                                                <th>Payor</th>
                                                <th>Payor Type</th>
                                                <th>Bucket Info</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Report Due</th>
                                                <th>Auth Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Build out dependent on the view */}

                                            {pastClientAuthorizations && pastClientAuthorizations.length > 0 ? pastClientAuthorizations.map(authorization =>
                                                <tr className="border border-gray-500 text-center">
                                                    <td className="border border-gray-500 p-2"><span>{authorization.cptcode}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.mod1 ? authorization.mod1 : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.mod2 ? authorization.mod2 : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.hoursAllowed ? authorization.hoursAllowed : "N/A"}</span></td>
                                                    <td className={"border border-gray-500 p-2 " + (authorization.proratedPercentageUtilized ? (authorization.proratedPercentageUtilized >= 90 && authorization.proratedPercentageUtilized <= 104) ? "bg-lacgreen-200" : "bg-rose-200" : "")}><span>{authorization.proratedPercentageUtilized ? authorization.proratedPercentageUtilized : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.providerName ? authorization.providerName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorName ? authorization.payorName : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.payorInfoType ? authorization.payorInfoType : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.bucket ? "Bucket" : "Non-Bucket"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.startDate ? new Date(authorization.startDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.endDate ? new Date(authorization.endDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.reportDueDate ? new Date(authorization.reportDueDate).toLocaleDateString() : "N/A"}</span></td>
                                                    <td className="border border-gray-500 p-2"><span>{authorization.status}</span></td>
                                                    <td onClick={e => HandleAuthorizationClick(authorization.authId, authorization.payorInfoType, authorization.clientId)} className="border border-gray-500"><FontAwesomeIcon className="text-lacblue w-7 h-7 m-auto hover:cursor-pointer" icon={solid('circle-info')} ></FontAwesomeIcon></td>
                                                </tr>
                                            ) : <tr><td colSpan={8} className="text-center text-rose">No Authorizations.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>


                    </div>

                </div>

            </div>

            <AuthorizationModal Client={selectedClientForModal} AuthId={selectedAuthId} AuthPayorType={selectedAuthPayorType} PayorInfoTypes={payorInfoTypes} AuthorizationStatuses={authorizationStatuses} AuthorizationDenialReasons={authDenialReasons} AuthorizationFeedbackOptions={authFeedbackOptions} AuthorizationActions={authActions} Active={isAuthorizationModalActive} setActive={setIsAuthorizationModalActive} OnModalClose={OnModalClose} IsInsurance={false}></AuthorizationModal>

            <ProfilePictureModal Client={selectedClientForModal} Active={profilePictureModalActive} setActive={setProfilePictureModalActive} OnModalClose={ProfilePictureOnCLose} />

            <ModalNotification Title={"Success!"} Body={"Data for " + edpnContext.selectedClient?.fullName + " successfully saved."} Active={successModalActive} Icon={"Success"} setActive={setSuccessModalActive} OnModalClose={SuccessModalClose} />
            <ModalNotification Title={"Error!"} Body={"Contact IT if this error persists. Error Message: " + errorMessage} Active={errorModalActive} Icon={"Warning"} setActive={setErrorModalActive} OnModalClose={function noop() { }} />
            <ModalConfirm Message={confirmDeleteModalMessage} Active={confirmDeleteModalActive} setActive={setConfirmDeleteModalActive} OnConfirm={DeleteAuth} />

        </div>

    );

};


export function EDPNLearnerInfo() {

    const authRequest = {
        ...loginRequest
    };

    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
                <ProtectedPage RequiredRoles={['EDPN.Read', 'EDPN.Write', 'EDPN.Approve', 'ECL.Read', 'ECL.Write', 'ECL.Approve', 'Outcomes.Write']}>
                    <EDPNLearnerInfoContent />
                </ProtectedPage>
            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>
        </>
    )
};